import { render, staticRenderFns } from "./PAQuickInfo.vue?vue&type=template&id=588086c8&"
import script from "./PAQuickInfo.vue?vue&type=script&lang=js&"
export * from "./PAQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./PAQuickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAQuickInfo.vue"
export default component.exports